/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/** GA ペイロード上のバリアント表現。判定側の型（common/core/abVariant の AbVariant）には依存させない */
export type AbTestAssignVariant = 'control' | 'variant';

export interface AbTestAssignParams {
  experiment_id: string;
  variant: AbTestAssignVariant;
}

/**
 * 発火タイミング：Optimize Next が実際の割当（0=control / 1+=variant）を返し、
 * 呼び出し元の画面の A/B バリアントが確定した際に1ページライフサイクルにつき1回発火する。
 * 未割当・タイムアウト・実験OFF（experiment ID 空文字）による control フォールバック時は発火しない。
 */
export const sendGAWabunkaAbTestAssignEvent = (experimentId: string, variant: AbTestAssignVariant) => {
  sendWabunkaGAEvent('ab_test_assign', {
    experiment_id: experimentId,
    variant,
  });
};
